module.exports = __webpack_public_path__ + "static/media/icn_info_red.fe8d6d87.svg";